module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10207.3a541e59.jpg";